import React from "react";
import Space from "../../../Common/Space";
import {Box, Typography} from "@mui/material";
import {CategoryFilterDesktop} from "./CategoryFilterDesktop";
import {CustomFilterDesktop} from "./CustomFiltersDesktop";
import {observer} from "mobx-react-lite";

export const SideBarFiltersDesktop = observer(() => {
    return <Box sx={{minWidth: "200px", maxWidth: "200px", paddingRight: "30px"}}>
        <CategoryFilterDesktop/>
        <Space height={"10px"}/>
        <CustomFilterDesktop/>
    </Box>
});